import moment from "moment";
import React from "react";
import { useLoaderData } from "react-router";
import ShowExternalEditApp from "./edit/AppForExternal";
import ShowInternalEditApp from "./edit/AppForInternal";
import { useClient, useCurrentUser } from "common/SessionContext";

export const ShowNewAppForInternal = () => {
  const currentUser = useCurrentUser();
  const client = useClient();
  const viewModel = useLoaderData<server.viewmodel.ShowNewInternalFrontModel>();

  const defaultStartDate = viewModel.defaultDate ? moment.utc(viewModel.defaultDate) : moment.utc().startOf("day");
  const defaultEndDate = viewModel.defaultDate ? moment.utc(viewModel.defaultDate) : moment.utc().startOf("day");

  return <ShowInternalEditApp
    exclusivityClause={null}
    ffCategories={viewModel.freeFieldCategories}
    ffPermissions={viewModel.freeFieldPermissions}
    optionsPanel={viewModel.optionsPanel}
    listUrl={viewModel.listUrl}
    statuses={viewModel.statuses}
    itineraryPanel={viewModel.itinerarySidebarPanel}
    hasAccessToAllArtists={viewModel.hasAccessToAllArtists}
    initialValues={{
      client: client,
      tour: viewModel.defaultProduction,
      showDates: {
        startDisplayDate: defaultStartDate,
        endDisplayDate: defaultEndDate,
        mode: "allDay",
        timeOfPerformance: ""
      },
      status: viewModel.statuses[0],
      eventName: "",
      eventWebsite: "",
      publicationStatus: site.userPreference.defaults.publication,
      costCenter: null,
      projectCode: "",
      tags: [],
      owner: currentUser,
      artist: viewModel.defaultArtist,
      attendees: [],
      venue: null,
      venueContact: null,
      capacity: null,
      ageRestriction: null,
      doors: { open: null, close: null },
      promoter: null,
      promoterContact: null,
      hotel: null,
      hotelContact: null,
      onSaleDate: null,
      soldOut: false,
      ticketLink: "",

      presalePrice: null,
      doorPrice: null,
      reducedPrice: null,

      bookkeeping: null,
      currency: "eur",
      exchangeRate: 1,

      freefieldValues: []
    }}
  />
}

export const ShowNewAppForExternal = () => {
  const viewModel = useLoaderData<server.viewmodel.ShowNewExternalFrontModel>();

  const defaultStartDate = viewModel.defaultDate ? moment.utc(viewModel.defaultDate) : moment.utc().startOf("day");
  const defaultEndDate = viewModel.defaultDate ? moment.utc(viewModel.defaultDate) : moment.utc().startOf("day");

  return <ShowExternalEditApp
    ffCategories={viewModel.freeFieldCategories}
    ffPermissions={viewModel.freeFieldPermissions}
    optionsPanel={viewModel.optionsPanel}
    listUrl={viewModel.listUrl}
    statuses={viewModel.statuses}
    initialValues={{
      client: viewModel.defaultClient,
      tour: viewModel.defaultProduction,
      showDates: {
        startDisplayDate: defaultStartDate,
        endDisplayDate: defaultEndDate,
        mode: "allDay",
        timeOfPerformance: ""
      },
      status: viewModel.statuses[0],
      eventName: "",
      eventWebsite: "",

      artist: viewModel.defaultArtist,

      freefieldValues: []
    }}
  />
}
